import { type FC } from "preact/compat";
import { type BlogPostCardProps } from "@services/wordpress/wordpress.types";
import classnames from 'classnames'
import './index.scss';

export const BlogPostCard: FC<BlogPostCardProps> = ({
  author,
  authorImage,
  categoryName,
  excerpt,
  featuredMedia,
  newStyles,
  link,
  title,
}) => {
  return (
    <a
      href={link}
      className={classnames(
        'blog-post-card w-full text-gt-black hover:text-gt-lilac-dark ease-in-out duration-300 group/post', {
          'blog-post-card--new-styles swiper-slide': newStyles,
        }
      )}
    >
      {featuredMedia && (
        <figure className="blog-post-card__image-container rounded-md overflow-hidden">
          <img
            alt={title}
            className="w-full h-64 object-cover group-hover/post:scale-110 ease-in-out duration-300"
            height={featuredMedia.media_details.height}
            src={featuredMedia.source_url}
            width={featuredMedia.media_details.width}
          />
        </figure>
      )}

      {categoryName && (
          <span
            className={classnames(
              'blog-post-card__badge inline-block text-sm py-1 px-4 mt-6 mb-4', {
                'bg-gt-lilac-light rounded-full': categoryName,
              }
            )}
          >
          {categoryName}
        </span>
      )}

      <h3
        className="blog-post-card__heading font-medium text-lg"
        dangerouslySetInnerHTML={{ __html: title }}
      />

      {excerpt && newStyles && (
        <div
          className="blog-post-card__excerpt w-full mt-2"
          dangerouslySetInnerHTML={{ __html: excerpt }}
        />
      )}

      {authorImage && author && (
        <figure className="blog-post-card__author mt-4 flex items-center justify-start gap-4 lg:mt-6">
          <img
            alt={title}
            className="blog-post-card__author-image w-12 h-12 object-cover rounded-md"
            height={authorImage.media_details.height}
            src={authorImage.source_url}
            width={authorImage.media_details.width}
          />
          <figcaption className="blog-post-card__author-text">
            {author}
          </figcaption>
        </figure>
      )}
    </a>
  );
};
